import React from 'react';
import { electronicCompanies } from '../utils/all-integrations.utils';
import IntegrationsCard from '../../../components/integrations-card/integrations-card';
import AppDialog from '@shared/components/app-dialog/app-dialog';
import IntegrationsPopopContent from '../../../components/integrations-popup/integrations-popup';
import { IntegrationItem } from '@shared/models/integrations/integrations.model';

const IntegrationsList: React.FC = () => {
  const [selectedIntegration, setSelectedIntegration] =
    React.useState<IntegrationItem | null>(null);

  const [showDialog, setShowDialog] = React.useState<boolean>(false);

  const changeSelectedIntegration = (item: IntegrationItem) => {
    setSelectedIntegration(item);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setSelectedIntegration(null);
  };

  return (
    <div className="w-full h-full">
      <div className="grid grid-cols-4 max-lg-xl:grid-cols-3 gap-4">
        {electronicCompanies.map((item) => {
          return (
            <IntegrationsCard
              key={item.id}
              item={item}
              onClick={changeSelectedIntegration}
            />
          );
        })}
      </div>

      <AppDialog
        title=""
        open={showDialog}
        size={'xl'}
        content={<IntegrationsPopopContent item={selectedIntegration} />}
        onClose={handleCloseDialog}
      />
    </div>
  );
};

export default IntegrationsList;
